import React from "react";
import styled from "styled-components";
import image1 from "../assets/Servicepages.png";
// import image2 from "../assets/gif-ourservices.gif"
import image3 from "../assets/Mobile Apps.png";
import image4 from "../assets/Mobile Games.png";
import image5 from "../assets/Website.png";

const WrapOurService = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const ServiceHead = styled.h1`
  margin-bottom: 20px;
`;

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
  max-width: 800px;
`;

const ServiceImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 10px;
`;

const Our_Services = () => {
  return (
    <>
      <WrapOurService>
        <ServiceImage src={image1} alt="Service Image 1" />
        <ImageGrid>
          <ServiceImage src={image5} alt="Service Image 2" />
          {/* <ServiceImage src={image3} alt="Service Image 3" /> */}
          <ServiceImage src={image4} alt="Service Image 4" />
        </ImageGrid>
      </WrapOurService>
    </>
  );
};

export default Our_Services;
